import { Grid } from "@mui/material";
import * as React from "react";
import { Create, required, TextInput } from "react-admin";
import { SimpleForm } from "src/enterprise/ra-rbac";
import { StickerCreateComponent } from "src/resources/product/sticker";
import { FileInput } from "../../../components/file-input/FileInput";

export const StickerCreate = () => (
  <Create component={StickerCreateComponent}>
    <SimpleForm>
      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item sm={12} lg={8}>
          <TextInput source="name" validate={required()} />
        </Grid>
        <Grid item sm={12} lg={6}>
            <FileInput
              source="image"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
              multiple={false}
            />
          </Grid>
      </Grid>
    </SimpleForm>
  </Create>
);
